import { ColorPicker } from "antd";

/**
 * Substitui o antd-colorpicker (v4-only) mantendo o contrato de dados legado:
 * o valor gravado é um objeto `{ hex }` (as telas consomem apenas `.hex`) e
 * valores antigos completos do react-color continuam sendo aceitos na leitura.
 */
const PRESETS = [
  {
    label: "Padrão",
    colors: [
      "#03a9f4", "#2d7ff9", "#0e9c84", "#4caf50", "#8bc34a",
      "#ffc107", "#e8a33d", "#ff5722", "#e5533c", "#e91e63",
      "#9c27b0", "#673ab7", "#607d8b", "#795548", "#1f2937",
    ],
  },
];

const SwatchColorPicker = ({ value, onChange, ...rest }) => {
  const hex = typeof value === "string" ? value : value?.hex;
  return (
    <ColorPicker
      value={hex || "#03a9f4"}
      onChange={(color) => onChange?.({ hex: color.toHexString() })}
      presets={PRESETS}
      showText
      {...rest}
    />
  );
};

export default SwatchColorPicker;
